export function classNames(classNamesArray) {
  if (!Array.isArray(classNamesArray)) {
    return null;
  }

  return classNamesArray
    .filter(className => typeof className === "string")
    .join(" ");
}
